<div class="modal-header">
  <h4 class="modal-title">{{ modal_header }}</h4>
  <button class="btn-close" type="button" aria-label="Close" (click)="dismissModal()"></button>
</div>

<div class="modal-body py-0">
  <span class="d-inline-block">
    {{ 'device_not_upgradable_until' | translate : date }}
  </span>
  <span class="d-inline-block">
    {{ 'upgrading_will_incur_additional_fees' | translate }}
  </span>
</div>

<div class="modal-footer border-top-0">
  <button class="btn btn-outline-secondary" type="button" (click)="dismissModal()">
    {{ 'cancel' | translate }}
  </button>
  <button class="btn btn-primary" type="button" (click)="continue()">
    {{ 'continue' | translate }}
  </button>
</div>
